export default function (...args)
{
	return {

		events: ['change'],

		getValue(default_value = Array.from(document.querySelectorAll(this.selector + '[checked]')).map(node => node.value).join(','), _this = this)
		{
			return this.safeProtoCall(default_value, _this);
		},

		refresh()
		{
			let values = this.getValue().split(',');
			let nodes = document.querySelectorAll(this.selector);
			nodes.forEach(node =>
			{
				node.checked = values.includes(node.value);
			});
		},

		handleEvents(ev)
		{
			let values = this.getValue().split(',');
			let index = values.findIndex(value => value == ev.target.value);
			if (index < 0)
				values.unshift(ev.target.value);	// Add if not found
			else
				values.splice(index, 1);			// Remove if found
			this.setValue(values.join(','));
		}

	};
}

